import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//招募计划相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/zmplan/sh/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/zmplan/sh/get/${params.id}`)
  },
  //发布
  fabu(params) {
    return axios.get(`${base.bs}/admin/zmplan/sh/fabu/${params.id}`,null)
  },
  //撤回发布
  chfabu(params) {
    return axios.get(`${base.bs}/admin/zmplan/sh/chfabu/${params.id}`,null)
  },
  //退回
  back(params) {
    return axios.get(`${base.bs}/admin/zmplan/sh/back/${params.id}`, {params:{option:params.option}})
  },
  //结束
  end(params) {
    return axios.get(`${base.bs}/admin/zmplan/sh/end/${params.id}`,null)
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/shZmPlan.js